export enum County {
    All = 'Hela Sverige',
    Stockholm = 'Stockholms Län',
    Uppsala = 'Uppsala Län',
    Sodermanland = 'Södermanlands Län',
    Ostergotland = 'Östergötlands Län',
    Jonkoping = 'Jönköpings Län',
    Kronoberg = 'Kronobergs Län',
    Kalmar = 'Kalmar Län',
    Gotland = 'Gotlands Län',
    Blekinge = 'Blekinge Län',
    Skane = 'Skåne Län',
    Halland = 'Hallands Län',
    VastraGotaland = 'Västra Götalands Län',
    Varmland = 'Värmlands Län',
    Orebro = 'Örebro Län',
    Vastmanland = 'Västmanlands Län',
    Dalarna = 'Dalarnas Län',
    Gavleborg = 'Gävleborgs Län',
    Vasternorrland = 'Västernorrlands Län',
    Jamtland = 'Jämtlands Län',
    Vasterbotten = 'Västerbottens Län',
    Norrbotten = 'Norrbottens Län',
}